import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'incentives',
  children: {
    list: {
      path: 'list',
    },
  },
} as const satisfies Location
